<template lang="pug">
    Modal(v-model="isModalOpened" :title="$t('nodeRegisteration.title')" width="800"  v-if="$store.getters.isAdmin|| !$store.getters.isAdmin&&hasPermission && $store.state.queryGroupName !== 'all'" @on-cancel="$emit('closeRegisterInfoModal')" transfer  :mask-closable="false")
            RadioGroup(v-show="showRegisterInfo == false" v-model="registerMethod" :style="{'width': '100%','display': 'flex', 'justify-content': 'space-around'}" size="large")
                div(v-if="$store.getters.isAdmin")
                    Radio(label="Inode_admin_only" border style="overflow: scroll")
                        .single-radio
                            pre Platform Base
                            pre(style="color: grey;padding: 8px") {{$t('nodeRegisteration.plateFormBaseDescription')}}
                div
                    Radio(label="Double_token" border style="overflow:scroll")
                        .single-radio
                            pre Group Token Base
                            pre(style="color: grey;padding: 8px") {{$t('nodeRegisteration.groupTokenBaseDescription')}}
            div(v-if="registerStep == 1")
                GroupListSelector(ref="groupSelector" :multiple="allowGroupMultiple" @updateGroupName="chooseGroupName = $event"  :disabled="$store.state.queryGroupName !== 'all'" :chooseGroupName="chooseGroupName")
                Row(type="flex" align="middle" v-if="$store.getters.isAdmin&&registerMethod == 'Inode_admin_only'")
                    Col(span="6")
                        pre {{ $t('global.select') }} {{ $t('slbsetting.serviceProvideType') }}
                    Col(span="18")
                        Select(v-model="chooseServiceProvideType" )
                            Option(v-for='item in serviceProvideTypeItems' :value="item.value" :key="item.value") {{ item.label }}
            Col(v-if="showRegisterInfo" style="text-align: center")
                NodeRegisterInfo(:registerMethod="registerMethod" :nodeType="nodeType" :chooseGroupName="chooseGroupName" :chooseServiceProvideType="chooseServiceProvideType")
            div(slot="footer")
                Tooltip(:content="canGoNextStep?'Continue':'Please Choose a group to continue'" v-if="registerStep == 1")
                    Button(type="primary" size="large"  @click="getRegisterInfo" :disabled="!canGoNextStep") {{$t('nodeRegisteration.nextStep')}}
                div(v-else style="display: flex; flex-direction: row; justify-content: space-between")
                    Button(type="default" size="large" @click="showRegisterInfo = false; registerStep = 1" :disabled="!$store.getters.isAdmin") {{$t('nodeRegisteration.preStep')}}
                    Button(type="primary" size="large" @click="closeRegisterInfoModal()") {{$t('nodeRegisteration.gotIt')}}
</template>

<script>
import NodeTokenListTable from "@/components/NodeRegisteration/NodeTokenListTable";
import GroupListSelector from "@/components/GroupListSelector";
import NodeRegisterInfo from "@/components/NodeRegisteration/NodeRegisterInfo";

import { _getNodeRegisterTokens } from "@/api/rest/index";
import { _getNodeRegisterCommands } from "@/api/group";

export default {
    props: {
        nodeType: { type: String, default: "slb" },
        hasPermission: { type: Boolean, default: false },
        isRegistrationInfoShown: { type: Boolean, default: false },
    },
    components: { NodeTokenListTable, GroupListSelector, NodeRegisterInfo },
    data() {
        return {
            isModalOpened: false,
            registerStep: 1,
            registerMethod: "",
            showRegisterInfo: false,
            chooseGroupName: this.$store.state.queryGroupName,
            serviceProvideTypeItems: [
                { label: "Normal", value: "normal" },
                { label: "Protect", value: "protect" },
            ],
            chooseServiceProvideType: "normal",
        };
    },
    watch: {
        isRegistrationInfoShown: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.isModalOpened = val;
                if (val == true) {
                    if (!this.$store.getters.isAdmin) {
                        this.getRegisterInfo();
                    }
                }
            },
        },
        registerMethod: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.chooseGroupName =
                    this.$store.getters.isAdmin &&
                    this.$store.state.queryGroupName == "all" &&
                    val == "Inode_admin_only"
                        ? "None"
                        : this.$store.getters.isAdmin &&
                          this.$store.state.queryGroupName == "all" &&
                          val == "Double_token"
                        ? this.$store.state.allGroupNames[0]
                        : this.$store.state.queryGroupName;
            },
        },
    },
    computed: {
        allowGroupMultiple() {
            return this.registerMethod !== "Double_token" &&
                this.chooseServiceProvideType == "protect" &&
                this.$store.state.queryGroupName == "all"
                ? true
                : false;
        },
        canGoNextStep() {
            return (this.registerMethod == "Double_token" &&
                this.$store.state.queryGroupName == "all" &&
                this.chooseGroupName == null) ||
                (this.registerMethod == "Double_token" &&
                    this.$store.state.queryGroupName == "all" &&
                    this.chooseGroupName == "")
                ? false
                : true;
        },
    },
    methods: {
        closeRegisterInfoModal() {
            this.isModalOpened = false;
            this.$emit("closeRegisterInfoModal", this.isModalOpened);
            // $emit('closeDependencyObjectAlert')
            this.showRegisterInfo = false;
            this.registerStep = 1;
        },
        async getRegisterInfo() {
            this.showRegisterInfo = true;
            this.registerStep = 2;
        },
    },
    mounted() {
        this.registerMethod =
            this.$store.getters.isAdmin && this.$store.state.queryGroupName == "all"
                ? "Inode_admin_only"
                : "Double_token";
    },
};
</script>

<style lang="less" scoped>
.ivu-radio-group-large .ivu-radio-border {
    min-height: 250px;
    max-width: 400px;
    .ivu-radio {
        display: none;
    }
}
.single-radio {
    display: inline-block;
    vertical-align: top;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NodeRegisteration/RegisterNodeInfoModal.vue